import PrintModal from '../PrintModal/print-modal';

export default PrintModal;